<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Create Purpose
            </h2>
        </template>

        <purpose-form :action="route('purposes.store')" method="POST" button="CREATE"></purpose-form>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import PurposeForm from './Form';

    export default {
        components: {
            AppLayout,
            PurposeForm,
        },
    }
</script>
